class CollectionPage {
  constructor() {
    this.addEventListeners();
    this.initObserver();
  }

  getElements() {
    return {
      productGridContainer: document.getElementById("ProductGridContainer"),
      paginationButtons: document.querySelectorAll(".pagination__item.link")
    }
  }

  initObserver() {
    const { productGridContainer } = this.getElements();
    
    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          this.addEventListeners();
        }
      }
    });
    
    observer.observe(productGridContainer, {
      childList: true,
    });
  }

  addEventListeners() {
    const { paginationButtons } = this.getElements();
  
    paginationButtons.forEach(button => {
      button.addEventListener("click", (evt) => this.handlePaginate(evt));
    });
  }

  handlePaginate(evt) {
    evt.preventDefault();
    
    const href = evt.target.closest('a').getAttribute("href");
    const { productGridContainer } = this.getElements();
  
    fetch(href)
      .then((res) => res.text())
      .then((html) => {
        // Render page from fetch
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        const gridNewContent = tempElement.querySelector("#ProductGridContainer").innerHTML;
        productGridContainer.innerHTML = gridNewContent;

        // Update URL
        history.pushState({ href }, '', href);

        // Scroll to the top of container
        window.scrollTo({
          top: productGridContainer.getBoundingClientRect().top + window.scrollY - 200,
          behavior: 'smooth'
        });
      });
  }
}

const collectionPage = new CollectionPage();
